import styled, { css } from 'styled-components'

const designerCSS = css`
  /*! CSS Used from: http://yolo.tino.me/app/resources/css/games_panel.css */
  .multiplier_slider {
    padding-top: 10px;
    padding-bottom: 15px;
    position: relative;
    z-index: 1;
    display: flex;
    flex-direction: column;
  }
  .multiplier_slider .value_buttons {
    display: grid;
    grid-template: 1fr / repeat(7, 1fr);
    flex-direction: row;
    margin: 2px 0 0 0;
    justify-content: space-between;
  }
  .multiplier_slider .value_buttons button {
    padding: 10px 6px;
    font-size: 0.65rem;
    font-weight: 600;
    border-radius: 0;
    border-right: 1px solid hsla(0, 0%, 100%, 0.15);
    background: hsl(221, 16%, 14%);
  }
  .multiplier_slider .value_buttons button:first-child {
    border-radius: 0 0 0 10px;
    background: linear-gradient(
      90deg,
      #2159d150,
      #2658d250,
      #2b57d350,
      #3055d350,
      #3454d450,
      #3953d550,
      #3d51d550,
      #4150d650
    );
  }
  .multiplier_slider .value_buttons button:nth-child(2) {
    background: linear-gradient(
      90deg,
      #4150d650,
      #464fd650,
      #4c4dd750,
      #514bd750,
      #564ad850,
      #5b48d850,
      #5f46d850,
      #6444d850
    );
  }
  .multiplier_slider .value_buttons button:nth-child(3) {
    background: linear-gradient(
      90deg,
      #6444d850,
      #6943d850,
      #6e41d750,
      #723fd750,
      #773ed650,
      #7b3cd550,
      #803ad550,
      #8438d450
    );
  }
  .multiplier_slider .value_buttons button:nth-child(4) {
    background: linear-gradient(
      90deg,
      #8438d450,
      #8936d250,
      #8d35d050,
      #9233cf50,
      #9631cd50,
      #9a2fcb50,
      #9e2dc950,
      #a22bc750
    );
  }
  .multiplier_slider .value_buttons button:nth-child(5) {
    background: linear-gradient(
      90deg,
      #a22bc750,
      #a629c450,
      #aa27c250,
      #ae25bf50,
      #b223bc50,
      #b521b950,
      #b91fb750,
      #bc1db450
    );
  }
  .multiplier_slider .value_buttons button:nth-child(6) {
    background: linear-gradient(
      90deg,
      #bc1db450,
      #bf1ab150,
      #c218ad50,
      #c516aa50,
      #c814a750,
      #ca12a450,
      #cd10a050,
      #cf0f9d50
    );
  }
  .multiplier_slider .value_buttons button:last-child {
    background: linear-gradient(
      90deg,
      #cf0f9d50,
      #d10c9a50,
      #d30a9750,
      #d4089450,
      #d6069150,
      #d7058e50,
      #d9058b50,
      #da058850
    );
    border-radius: 0 0 10px 0;
    border-right: 0;
  }
  .multiplier_slider:hover .value_buttons button:first-child {
    background: linear-gradient(
      90deg,
      #2159d180,
      #2658d280,
      #2b57d380,
      #3055d380,
      #3454d480,
      #3953d580,
      #3d51d580,
      #4150d680
    );
  }
  .multiplier_slider:hover .value_buttons button:nth-child(2) {
    background: linear-gradient(
      90deg,
      #4150d680,
      #464fd680,
      #4c4dd780,
      #514bd780,
      #564ad880,
      #5b48d880,
      #5f46d880,
      #6444d880
    );
  }
  .multiplier_slider:hover .value_buttons button:nth-child(3) {
    background: linear-gradient(
      90deg,
      #6444d880,
      #6943d880,
      #6e41d780,
      #723fd780,
      #773ed680,
      #7b3cd580,
      #803ad580,
      #8438d480
    );
  }
  .multiplier_slider:hover .value_buttons button:nth-child(4) {
    background: linear-gradient(
      90deg,
      #8438d480,
      #8936d280,
      #8d35d080,
      #9233cf80,
      #9631cd80,
      #9a2fcb80,
      #9e2dc980,
      #a22bc780
    );
  }
  .multiplier_slider:hover .value_buttons button:nth-child(5) {
    background: linear-gradient(
      90deg,
      #a22bc780,
      #a629c480,
      #aa27c280,
      #ae25bf80,
      #b223bc80,
      #b521b980,
      #b91fb780,
      #bc1db480
    );
  }
  .multiplier_slider:hover .value_buttons button:nth-child(6) {
    background: linear-gradient(
      90deg,
      #bc1db480,
      #bf1ab180,
      #c218ad80,
      #c516aa80,
      #c814a780,
      #ca12a480,
      #cd10a080,
      #cf0f9d80
    );
  }
  .multiplier_slider:hover .value_buttons button:last-child {
    background: linear-gradient(
      90deg,
      #cf0f9d80,
      #d10c9a80,
      #d30a9780,
      #d4089480,
      #d6069180,
      #d7058e80,
      #d9058b80,
      #da058880
    );
    border-radius: 0 0 10px 0;
    border-right: 0;
  }
  .multiplier_slider .value_buttons button:first-child:hover {
    background: linear-gradient(90deg, #2159d1, #2658d2, #2b57d3, #3055d3, #3454d4, #3953d5, #3d51d5, #4150d6);
  }
  .multiplier_slider .value_buttons button:nth-child(2):hover {
    background: linear-gradient(90deg, #4150d6, #464fd6, #4c4dd7, #514bd7, #564ad8, #5b48d8, #5f46d8, #6444d8);
  }
  .multiplier_slider .value_buttons button:nth-child(3):hover {
    background: linear-gradient(90deg, #6444d8, #6943d8, #6e41d7, #723fd7, #773ed6, #7b3cd5, #803ad5, #8438d4);
  }
  .multiplier_slider .value_buttons button:nth-child(4):hover {
    background: linear-gradient(90deg, #8438d4, #8936d2, #8d35d0, #9233cf, #9631cd, #9a2fcb, #9e2dc9, #a22bc7);
  }
  .multiplier_slider .value_buttons button:nth-child(5):hover {
    background: linear-gradient(90deg, #a22bc7, #a629c4, #aa27c2, #ae25bf, #b223bc, #b521b9, #b91fb7, #bc1db4);
  }
  .multiplier_slider .value_buttons button:nth-child(6):hover {
    background: linear-gradient(90deg, #bc1db4, #bf1ab1, #c218ad, #c516aa, #c814a7, #ca12a4, #cd10a0, #cf0f9d);
  }
  .multiplier_slider .value_buttons button:last-child:hover {
    background: linear-gradient(90deg, #cf0f9d, #d10c9a, #d30a97, #d40894, #d60691, #d7058e, #d9058b, #da0588);
    border-radius: 0 0 10px 0;
    border-right: 0;
  }
  .multiplier_slider_labels {
    position: relative;
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
  .multiplier_slider_labels label {
    padding: 10px 0 0 0;
    position: relative;
  }
  .multiplier_slider_labels label span {
    display: flex;
    position: relative;
    font-size: 0.7rem;
  }
  .multiplier_slider_labels label.green span {
    color: #3172ff;
  }
  .multiplier_slider_labels label.red span {
    color: #e30473;
  }
  details button {
    width: 100%;
    text-align: center;
    font-size: 0.8rem;
    text-transform: uppercase;
    padding: 15px 0;
    line-height: 100%;
    font-weight: 500;
  }
`

const inputSliderCSS = css`
  /*! CSS Used from: http://yolo.tino.me/app/resources/css/games_panel.css */
  input[type='range'].range_slider,
  input[type='range'].range_slider::-webkit-slider-runnable-track {
    border-radius: 1em;
    width: 100%;
    transition: box-shadow 0.2s ease-in-out;
    overflow: hidden;
    height: 20px;
    -webkit-appearance: none;
    background: hsl(221, 16%, 14%);
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
  }
  input[type='range'].range_slider::-webkit-slider-thumb {
    width: 20px;
    -webkit-appearance: none;
    height: 20px;
    cursor: ew-resize;
    background: hsl(221, 73%, 47%);
    box-shadow: -328px 0 0 320px hsl(221, 73%, 47%), inset 0 0 0 30px hsl(221, 73%, 47%);
    box-shadow: -328px 0 0 320px hsl(221, 73%, 47%), inset 0 0 0 30px #fff;
    border-radius: 50%;
    transition: box-shadow 0.2s ease-in-out;
    position: relative;
    border: 2px solid #fff;
  }
  input[type='range'].range_slider:active::-webkit-slider-thumb {
    background: hsl(221, 73%, 47%);
    box-shadow: -328px 0 0 320px hsl(221, 73%, 47%), inset 0 0 0 3px hsl(221, 73%, 47%);
  }
  input[type='range'].range_slider::-moz-range-progress,
  input[type='range'].range_slider::-moz-range-track,
  input[type='range'].range_slider::-ms-fill-lower,
  input[type='range'].range_slider::-ms-fill-upper {
    background: hsl(221, 73%, 47%);
  }
`
const developerCSS = css``

export const MultiplierSliderCSS = styled.div`
  width: 100%;
  ${designerCSS}
  ${inputSliderCSS}
  ${developerCSS}
`
